import React from "react";
import {
  Grid,
  CircularProgress,
  Icon,
  IconButton,
  Button,
  Divider,
  MenuItem,
} from "@material-ui/core";
import Menu from "../../../common/components/input/Menu/Menu";
import { observer, inject } from "mobx-react";

function RecipientsButton({
  store,
  reminder,
  onChange,
  isDefaultOpen = false,
  isNotificationEnabled = true,
  ...props
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isOpen, setOpen] = React.useState(isDefaultOpen);

  const { sheetRoles, sheetUsersFormatted, sheetColumnsFormatted } = store;
  const selectedRecipients = reminder.data?.recipients || [];
  const additionalEmails = reminder.data?.additional_emails;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const checkAndPushDataToArray = (data, item) => {
    const reciepientKey = data.indexOf(item["alias_name"]);

    if (reciepientKey !== -1) {
      data.splice(reciepientKey, 1);
    } else {
      data.push(item.alias_name);
    }
  };

  const onMenuItemClick = (item) => {
    const options = typeof item?.options === 'string' ? JSON.parse(item.options) : item?.options || [];
    if (item.type == "role" || (item.type == "column" && options.length > 0 && options[0].column_type === "email") || (item.type === "column" && item.column_type_id == 14)) {
      checkAndPushDataToArray(reminder.data?.recipients, item);
      onChange();
    } else if (item.type == "email") {
      checkAndPushDataToArray(reminder.data?.additional_emails, item);
      onChange();
    }

  };

  return (
    <Grid item>
      <IconButton
        aria-label="recipients"
        onClick={handleClick}
        ref={setAnchorEl}
      >
        <Icon className="fas fa-users" />
      </IconButton>
      <Menu
        open={isOpen}
        menuItems={[
          <MenuItem>
            <b>Share with</b>
          </MenuItem>,
          ...sheetRoles,
          <Divider />,
          ...sheetUsersFormatted,
          <Divider />,
          ...sheetColumnsFormatted,
        ]}
        anchorElement={anchorEl}
        onClose={handleClose}
        isNotificationEnabled={isNotificationEnabled}
        valueKey={"alias_name"}
        isCheckBox={true}
        checkedValues={[...selectedRecipients, ...additionalEmails]}
        filterFunction={(col) => {
          if (!col.column_type_id) {
            return true;
          }
          // if (col.column_type_id == 10) {
          //   const options = JSON.parse(col?.options || "[]");
          //   if (options[0]?.is_user_type) {
          //     return true;
          //   }
          // }
          if(col.column_type_id==10 || col.column_type_id==14)
          {
            return true;
          }
          return false;
        }}
        header={
          false && (
            <div>
              <Button onClick={store.handleUpdate} color="primary">
                Update
              </Button>
              <Button onClick={store.handleClose}>Cancel</Button>
            </div>
          )
        }
        // displayKey={displayKey}
        onChange={onChange}
        onMenuItemClick={onMenuItemClick}
      />
    </Grid>
  );
}

export default observer(RecipientsButton);
